export default __webpack_public_path__ + "static/media/bg_register.9eda3337.jpg";